/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_No_Options_AvailableInputs */

const en_general_no_options_available = /** @type {(inputs: General_No_Options_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No options available`)
};

/**
* | output |
* | --- |
* | "No options available" |
*
* @param {General_No_Options_AvailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const general_no_options_available = /** @type {((inputs?: General_No_Options_AvailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_No_Options_AvailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_general_no_options_available(inputs)
});